<template>
  <div class="bg_gray">
    <top-header :type="6" :placeholder="'商品房合同备案注销公示'" :hasBorder="true" :bgColor="'#fff'" fontSize="0.32rem" />
    <div>
      <div class="pad_t"></div>
      <div class="fixed_ m_flex_box flex_vc flex_jz">
        <van-search v-model="value" placeholder="请输入搜索关键词" @search="search" />
        <van-overlay :show="Boolean(projectList.length)">
        </van-overlay>
        <div class="wrapper" v-show="projectList.length">
          <div class="select_con">
            <div class="m_flex_box flex_vc flex_jz row" v-for="(item, index) in projectList" :key="index">
              <p class="left line_comp1" @click="setVal(item.tgmc, item.itemId)">[{{item.xzqh | getAreaName()}}] {{item.tgmc}}({{item.xmmc}})</p>
            </div>
          </div>
        </div>

        <p class="header_address m_flex_box flex_vc">
          <span @click="showPicker = true">{{area}}</span>
        </p>
      </div>
      <p class="tips">* 注销数据截止到当日0点</p><!--截止日期未绑定-->
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="no_data" v-if="!list.length">
          <img src="@/assets/img/nodata.png" alt="">
        </div>
        <div class="inner" v-for="(item, index) in list" :key="index"   >
          <h4>{{item.xmmc}}</h4>
          <p>推广名称：{{item.tgmc}}</p>
          <p>开发企业：{{item.corpName}}</p>
          <p class="three">
            <span>楼号：{{item.buildingName}}</span>
            <span>单元号：{{item.unitNo}}</span>
            <span>房号：{{item.houseNo}}</span>
          </p>
          <p class="m_flex_box">
            <span class="flex-1">注销时间：{{item.logOutDate}}</span><span class="flex-1">锁定时间：{{item.xfsj}}日</span>
          </p>
        </div>
      </van-list>
    </van-pull-refresh>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
                show-toolbar
                value-key="xzqh_name"
                :columns="xzqhArray"
                @confirm="onConfirm"
                @cancel="showPicker = false"
        />
      </van-popup>
    </div>
    <slide-img></slide-img>
  </div>
</template>

<script>
import qs from 'qs';
import topHeader from '@/components/header';
import slideImg from '@/components/slideImg'
export default {
  data() {
    return {
      isLoading: false,
      showPicker: false,
      loading: false,
      finished: false,
      list: [],
      value: '',
      listPage: 1,
      timer: null,
      xzqhArray:[],
      showProject: false,
      xzqhDefault:this.main.getHostArea(),
      items:'',
      area:'',
      xzqh:this.main.getHostArea(),
      jsonArr: [],
      projectList: [],
      keyWord:'',
      itemId:'',
      projectName:'',
    };
  },
  components: {
    topHeader,
    slideImg
  },
  watch: {
    value(n) {
      this.$set(this, 'projectList', [])
      const newArr = []
      this.jsonArr.forEach(function (item) {
        if ((item.tgmc.includes(n)|| item.xmmc.includes(n))) {
          newArr.push(item)
        }
      })
      this.$set(this, 'projectList', newArr);
      if(n === '') {
        this.$set(this, 'projectList', [])
      }
    }
  },


  filters: {
    getAreaName (value) {
      if (value == '320200') {
        return '主城区'; //主城区
      }else if (value == '320302') {
        return '鼓楼区';
      }else if (value == '320311') {
        return '泉山区';
      }else if (value == '320303') {
        return '云龙区';
      }else if (value == '320398') {
        return '开发区';
      }else if (value == '320312') {
        return '铜山区';
      }else if (value == '320399') {
        return '高新区';
      }else if (value == '320397') {
        return '港务区';
      }else if (value == '320305') {
        return '贾汪区';
      } else if (value == '320321') {
        return '丰县';
      } else if (value == '320381') {
        return '新沂市';
      } else if (value == '320324') {
        return '睢宁县';
      } else if (value == '320322') {
        return '沛县';
      } else if (value == '320382') {
        return '邳州市';
      } else {
        return '主城区';
      }
    }
  },



  mounted() {
   this.getArea();
   this.getProjectName();
  },
  methods: {
    onRefresh() {
      this.$set(this, 'listPage', 1);
      this.finished = false;
      this.loading = false,
      this.$set(this, 'list', []);
      this.onLoad(1);
    },

    onConfirm(data) {
      this.area = data.xzqh_name;
      this.showPicker = false;
      this.$set(this, 'xzqh', data.xzqh_code);
      this.$set(this, 'listPage', 1);
      this.finished = false;
      this.loading = false,
      this.$set(this, 'list', []);
      this.onLoad();
    },

    // 获取默认的行政区划
    getArea() {
      this.$new.post('xzqh/getXzqh.do').then(res => {
        if(res.obj) {
          if(this.xzqhDefault==='320300'){
            this.xzqhArray = res.obj[0].xzqhs;
            this.items = {xzqh_code:'320300',xzqh_name:'主城区'};
            this.xzqhArray.splice(0,0, this.items);
            this.area ='主城区'
          }else{
            res.obj.forEach((item) => {
              if(this.xzqhDefault===item.xzqh_code){
                this.$set(this, 'xzqhArray', [item])
                this.area = item.xzqh_name
              }
            });
          }
        }
      })
    },

    onLoad(type) {
      if(!this.timer){
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$new.post('houseApi/getLogoutHouseList.do', qs.stringify({
          xzqh: this.xzqh,
          pageSize:10,
          currPageNo:this.listPage,
         // mc:this.value
          itemId:this.itemId,
        })).then(res => {
          if(type) {
            this.isLoading = false;
          }
            if(res.success) {
              this.loading = false;
              this.list = this.list.concat(res.obj)
              this.loading = false;
              this.listPage += 1;
            } else {
              this.finished = true;
            }
        })
      }
    },

    setVal(name, id) {
      this.projectName = name;
      this.$set(this, 'itemId', id);
      this.$set(this, 'projectList', [])
      this.showProject = false;
      this.$set(this, 'listPage', 1);
      this.finished = false;
      this.loading = false,
      this.$set(this, 'list', []);
      this.onLoad();
    },

    getProjectName() {
      this.$new.post('/itemInfo/getItemSearch.do').then(res => {
        this.jsonArr = res.obj
      })
    },

    search() {
      this.$set(this, 'itemId', '');
      this.$set(this, 'listPage', 1);
      this.loading = false;
      this.finished = false;
      this.$set(this, 'list', []);
      this.onLoad();
    }
  },
};
</script>
<style lang="less" scoped>
  .select_con{
    position: fixed;
    top: 1.9rem;
    background-color: #fff;
    left: 0;
    right: 0;
    height: 60vh;
    overflow: auto;
    padding: 0.23rem;
    font-size: 0.26rem;
    z-index: 5;
    .row{
      height: 0.8rem;
      border-bottom: 1px solid #f5f5f5;
      p{
        font-size: #303030;
      }
      span, i{
        color: #A0A0A0;
        font-size: 0.24rem;
      }
      .left{
        width: 82%;
      }
    }
  }
  /deep/
  .van-overlay{
    top: 1.9rem;
  }
  .header_address{
    padding-right: 12px;
    font-size: 0.28rem;
    font-weight: 600;
    cursor: pointer;
    &.white{
      &:after{
        border-color: #fff transparent transparent transparent;
      }
    }
    &:after{
      content: '';
      display: block;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0.08rem;
      margin-left: 0.1rem;
      margin-top: 0.08rem;
      border-color: #202020 transparent transparent transparent;
    }
  }
  /deep/
  .van-search{
    width: 75%;
  }
  .fixed_{
    position: fixed;
    top: 0.9rem;
    left: 0;
    right: 0;
    background-color: #fff;
    z-index: 3;
  }
  .pad_t{
    padding-top: 54px;
  }
  .tips{
    color: #3AA9F6;
    font-size: 0.24rem;
    background-color: #E4F5FF;
    line-height: 0.6rem;
    padding: 0 0.23rem;
  }
  .bg_gray{
    background-color: #f4f4f4;
    min-height: 100vh;
  }
  .inner{
    padding: 0.28rem 0.23rem;
    background-color: #fff;
    margin-bottom: 0.12rem;
    h4{
      color: #3299FF;
      font-size: 0.26rem;
      font-weight: 800;
      margin-bottom: 0.16rem;
    }
    p{
      font-size: 0.24rem;
      color: #303030;
      margin-bottom: 0.1rem;
      &:last-child{
        margin-bottom: 0;
      }
    }
    .three{
      span{
        margin-right: 0.6rem;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
</style>